module.exports = __webpack_public_path__ + "static/media/cppLogo.c64a068e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Technologies/Assets/cppLogo.svg
// module id = 515
// module chunks = 1